import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LabelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"label"}/>
}
